import { CollectionState, FiltersMap } from '@wix/bex-core';

export interface CollectionFoldersBaseConfig<
  T1,
  F1 extends FiltersMap,
  T2,
  F2 extends FiltersMap,
> {
  /** A [collection state](/pages/cairo/?path=/story/common-hooks--usecollection) that fetches items */
  items: CollectionState<T1, F1>;
  /** A [collection state](/pages/cairo/?path=/story/common-hooks--usecollection) that fetches folders */
  folders: CollectionState<T2, F2>;
}
